import MarkdownIt from 'markdown-it'

export type LegalVars = {
  platformUrl?: string
  rt?: {
    organismeName?: string
    contactAddress?: string
    dpoName?: string
    dpoEmail?: string
  }
}

export type RenderResult = {
  html: string
  missingVars: string[]
}

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: false,
})

const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, _env, self) {
  return self.renderToken(tokens, idx, options)
}

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  const hrefIndex = tokens[idx].attrIndex('href')
  const href = String(hrefIndex >= 0 ? (tokens[idx].attrs?.[hrefIndex]?.[1] ?? '') : '')
  const isExternal = /^(https?:)?\/\//i.test(href) || /^(mailto|tel):/i.test(href)

  if (isExternal) {
    const targetIndex = tokens[idx].attrIndex('target')
    if (targetIndex < 0) {
      tokens[idx].attrPush(['target', '_blank'])
    } else {
      const attrs = tokens[idx].attrs
      if (attrs) attrs[targetIndex][1] = '_blank'
    }
    const relIndex = tokens[idx].attrIndex('rel')
    if (relIndex < 0) {
      tokens[idx].attrPush(['rel', 'noopener noreferrer'])
    }
  }
  return defaultRender(tokens, idx, options, env, self)
}

function resolveVar(path: string, vars: LegalVars): string | undefined {
  const segments = path.split('.')
  let current: unknown = vars
  for (const segment of segments) {
    if (current == null || typeof current !== 'object') return undefined
    current = (current as Record<string, unknown>)[segment]
  }
  return typeof current === 'string' && current.trim() !== '' ? current : undefined
}

export function renderLegalDoc(template: string, vars: LegalVars): RenderResult {
  const missingVars: string[] = []
  const interpolated = template.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_match, path: string) => {
    const value = resolveVar(path, vars)
    if (value === undefined) {
      if (!missingVars.includes(path)) missingVars.push(path)
      return `{{${path}}}`
    }
    return value
  })

  return {
    html: md.render(interpolated),
    missingVars,
  }
}
